
{
  "title": "Explore Hong Kong Services",
  "searchPlaceholder": "Search by service, area or provider",
  "sortBy": "Sort by",
  "sortOptions": {
    "featured": "Featured",
    "rating": "Highest Rated",
    "reviews": "Most Reviews",
    "nameAsc": "Name A-Z",
    "nameDesc": "Name Z-A"
  },
  "filters": {
    "category": "Category",
    "location": "Location",
    "rating": "Rating",
    "clearAll": "Clear All"
  },
  "providers": {
    "loading": "Loading providers...",
    "providerCount": "{{count}} provider found",
    "providerCount_plural": "{{count}} providers found",
    "provider": "provider",
    "provider_plural": "providers",
    "loadMore": "Load More",
    "searchResults": "Search results for \"{{query}}\"",
    "categoryResults": "{{category}} services",
    "favoriteResults": "Your favorite providers",
    "noResults": {
      "title": "No providers found",
      "description": "Try another service, area, or provider name."
    }
  }
}
